import s from './QuestionDetails.module.css';
import { Modal } from 'components/common/Modal/Modal';
import { ScrollableContainer } from 'components/common/ScrollableContainer';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';
import { useOutletContext } from 'react-router-dom';

export const QuestionDetails = () => {
  const { closeRouteModal, goBack } =
    useOutletContext<ModalNavigationContext>();

  return (
    <Modal title={'Question Details'} onClose={closeRouteModal} onBack={goBack}>
      <div className={s.container}>
        <ScrollableContainer scrollHeight='40rem'>
          Question Details
        </ScrollableContainer>
      </div>
    </Modal>
  );
};
